import { PdfEntityByAcademicYearList } from 'components/pdfStudent';
import { splitEntitiesByAcademicYear } from 'containers/pdfStudent/utils/splitEntitiesByAcademicYear';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetCultureOnlineEvents } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { getDataLoadRequests } from 'utils';

import { cultureOnlineEventsSelector } from '../../../../selectors';
import PdfCommonDataEntityContainer from '../common';

import '../index.scss';
import './index.scss';

const PdfCultureEventContainer = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const cultureOnlineEvents = useAppSelector(cultureOnlineEventsSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().cultureOnlineVisitings });

  const hasData = cultureOnlineEvents.content.length > 0;
  const academicYearData = splitEntitiesByAcademicYear(cultureOnlineEvents, academicYears);

  return (
    <PdfCommonDataEntityContainer title="Посещение культурных онлайн-мероприятий" Icon={IconWidgetCultureOnlineEvents}>
      {hasData && <PdfEntityByAcademicYearList academicYearData={academicYearData} />}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfCultureEventContainer;
